<template>

  <div>
    <div class="card">
      <div 
        v-for="(question, question_index) in value.questions"
        :key="question_index">
        <div class="card-header">
          <div class="d-flex">
            <div class="w-100 pr-3"><strong>{{ question.label }}</strong></div>
            <div>
              <div class="input-group mb-3" style="max-width: 110px">
                <input type="text" class="form-control" placeholder="0" v-model="question.score">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2">/{{ question.score_weight }}</span>
                </div>
              </div>
              <ValidateMessage :error="validateErrors['questions.' + question_index + '.score']" />
            </div>
          </div>
        </div>
        <div class="card-body" v-if="question.type !== 'radio' && question.type !== 'checkbox'">
          {{ question.answer }}  
        </div>
        <ul class="list-group list-group-flush" v-if="question.type === 'radio' || question.type === 'checkbox'">
          <li 
            class="list-group-item" 
            v-for="(option, item_index) in question.options" 
            :key="item_index"
            :class="checkChoice(option, question.answer, question.answers)">
            {{ option.title }}
            <span class="badge badge-success" v-if="option.correct">{{ $t('Correct') }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="mt-3" :class="{'box-loading': loading}">
      <button
        type="submit"
        class="btn btn-primary"
        @click="updateQuestionnaire(value)">
        {{ $t('Save') }}
        </button>
      <button
        v-if="value._id"
        type="submit"
        class="btn btn-light"
        @click="$emit('cancel')">
        {{ $t('Cancel') }}
        </button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CandidateQuestionnaireForm',
  components: {
  },
  props: [
    'initValue'
  ],
  data () {
    return {
      validateErrors: false,
      loading: false,
      value: this.defaultValues(this.initValue)
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    updateQuestionnaire
    */
    updateQuestionnaire (data) {
      this.loading = true

      this.$store
      .dispatch('updateQuestionnaire', data)
      .then((result) => {
        this.loading = false
        this.$emit('updated', data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    checkChoice (option, answer, answers) {
      const check = (answer)
      ? option.title === answer
      : answers.includes(option.title)

      return {'list-group-item-danger': check && !option.correct, 'list-group-item-success': check && option.correct}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Questionnaire/CandidateQuestionnaireForm.vue